import BrowseSection from "components/BrowseSection";
import Bison from "components/projects/Bison";
import Farmshare from "components/projects/Farmshare";
import FestivalDust from "components/projects/FestivalDust";
import TopSection from "components/TopSection";
import React, { useRef, useState, createContext } from "react";
import { cxProjects, projects } from "data";
import Houzz from "components/projects/Houzz";
import { Typography } from "@mui/material";
import SectionContainer from "ui-components/SectionContainer";
import ProjectDetails from "components/projects/ProjectDetails";

export const SectionContext = createContext({});
export const SectionProvider = SectionContext.Provider;

const PortfolioContent = ({ refsMap }) => (
	<>
		<BrowseSection refsMap={refsMap} />
		<FestivalDust ref={refsMap["festival-dust"]} />
		<Farmshare ref={refsMap["farmshare"]} />
		<Houzz ref={refsMap["houzz"]} />
		<Bison ref={refsMap["bison"]} />
	</>
);

const CXContent = () => (
	// <SectionContainer>
	// 	<Typography variant='h2' sx={{ fontWeight: "bold", marginBottom: 2 }}>
	// 		About
	// 	</Typography>
	// 	<Typography>
	// 		This is a placeholder for the About page. Swap this out with real content
	// 		whenever you&apos;re ready.
	// 	</Typography>
	// </SectionContainer>
	<>
	{cxProjects.map((project) => (
		<ProjectDetails key={project.sectionId} project={project} />
	))}
	</>
);

const Home = () => {
	const [page, setPage] = useState("portfolio");
	const refsMap = useRef({});

	projects.forEach((item) => {
		if (item.sectionId && !refsMap.current[item.sectionId]) {
			refsMap.current[item.sectionId] = React.createRef();
		}
	});

	return (
		<>
			<TopSection page={page} onPageChange={setPage} />
			{page === "portfolio" ? (
				<PortfolioContent refsMap={refsMap.current} />
			) : (
				<CXContent />
			)}
		</>
	);
};

export default Home;
